module.exports = __webpack_public_path__ + "static/media/background_dot.a45ab620.png";